import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Stethoscope, MapPin, Clock, Phone } from "lucide-react";

export function HcNurseVisits() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const load = () => api.get("/pro/healthcare/jobs").then((r) => setRows(r.data || [])).catch(() => {});
        load();
        const t = setInterval(load, 20000);
        return () => clearInterval(t);
    }, []);
    if (!rows.length) return null;
    return (
        <div className="mb-6" data-testid="pro-hc-visits">
            <h2 className="mb-3 font-heading text-lg font-bold text-navy">Nursing visits ({rows.length})</h2>
            <div className="space-y-3">
                {rows.map((v) => (
                    <div key={v.id} data-testid={`pro-hc-visit-${v.ref}`} className="rounded-2xl border border-teal/20 bg-white p-4 text-sm">
                        <div className="flex items-center justify-between gap-2">
                            <p className="flex items-center gap-1.5 font-bold text-navy"><Stethoscope size={15} className="text-teal" /> {v.kind_label} · {v.ref}</p>
                            <span className="rounded-full bg-aqua-light px-2.5 py-0.5 text-[11px] font-bold text-teal-dark">{v.status}</span>
                        </div>
                        <p className="mt-2 font-semibold text-navy">{v.patient_name}</p>
                        <p className="mt-1 flex items-center gap-1.5 text-xs text-navy/60"><Clock size={12} /> {v.date} · {v.slot}</p>
                        {v.address && <p className="mt-1 flex items-center gap-1.5 text-xs text-navy/60"><MapPin size={12} /> {v.address}</p>}
                        {v.contact_phone && <a data-testid={`pro-hc-call-${v.ref}`} href={`tel:${v.contact_phone}`} className="mt-1 flex items-center gap-1.5 text-xs font-bold text-teal"><Phone size={12} /> {v.contact_name || "Contact"} · {v.contact_phone}</a>}
                        {v.instructions && <p className="mt-1 text-xs text-navy/50">Note: {v.instructions}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
}
